// Muestra la razón con que se canceló/anuló una factura (columna razonanula
// que devuelve el backend). Sin razón no muestra nada: es un campo opcional.
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";
import { FP } from "./tokens";

const limpia = (razon) => String(razon || "").trim();

// Envuelve el chip "Anulada"/"Cancelada" de un listado: al pasar el cursor
// se ve la razón.
export function TooltipRazonCancelacion({ razon, children }) {
  const texto = limpia(razon);
  if (!texto) return children;
  return (
    <Tooltip title={`Razón: ${texto}`} arrow>
      <span>{children}</span>
    </Tooltip>
  );
}

TooltipRazonCancelacion.propTypes = {
  razon: PropTypes.string,
  children: PropTypes.node.isRequired,
};

TooltipRazonCancelacion.defaultProps = {
  razon: "",
};

// Línea visible para el detalle de una factura anulada.
export function RazonCancelacionTexto({ razon, sx }) {
  const texto = limpia(razon);
  if (!texto) return null;
  return (
    <Typography sx={{ fontSize: "0.85rem", color: FP.color.danger, ...sx }}>
      <b>Razón de la anulación:</b> {texto}
    </Typography>
  );
}

RazonCancelacionTexto.propTypes = {
  razon: PropTypes.string,
  sx: PropTypes.shape({}),
};

RazonCancelacionTexto.defaultProps = {
  razon: "",
  sx: {},
};
